import Swiper from 'swiper'
import { debounce } from '~/utils/utils'
import { getBreakpoint } from '../utils/utils'

const productGallery = () => ({
  swiper: null,
  activeIndex: 0,
  handleResize: () => { },

  init() {
    this.initSwiper()
    this.handleResize = debounce(() => this.initSwiper(), 500)
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('refreshSwiper', () => this.refreshSwiper())
  },

  initSwiper() {
    this.swiper?.destroy?.()
    this.swiper = null

    if (this.$refs?.swiperEl && window.innerWidth < getBreakpoint('lg')) {
      this.swiper = new Swiper(this.$refs.swiperEl, {
        slidesPerView: 1,
        on: {
          slideChange: function (s) {
            this.activeIndex = s.activeIndex
            console.log(this.activeIndex);
            s.el?.querySelectorAll('[data-bullet-index]').forEach((el) => {
              el.classList.remove('active')
            })
            s.el?.querySelector(`[data-bullet-index="${s.activeIndex}"]`).classList.add('active')
          },
          init: function (s) {
            this.activeIndex = s.activeIndex
            s.el?.querySelector(`[data-bullet-index="${s.activeIndex}"]`).classList.add('active')
          },
        },
      })
    }
  },

  refreshSwiper() {
    this.swiper?.update?.()
  },

  destroy() {
    this.swiper?.destroy?.()
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('refreshSwiper', () => this.refreshSwiper)
  },
})

export default productGallery
